// src/pages/admin/AdminLogin.jsx
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { setAdminToken } from "./auth";

export default function AdminLogin() {
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [err, setErr] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from || "/admin";

  const onSubmit = (e) => {
    e.preventDefault();
    setErr("");

    // ✅ مؤقت: دخول للواجهة فقط (نربطه بباك-إند في الخطوة التالية)
    if (user.trim() === "" || pass.trim() === "") {
      setErr("فضلاً أدخل اسم المستخدم وكلمة المرور");
      return;
    }

    // Token بسيط لتفعيل الحماية (يستبدل لاحقًا بتوكن حقيقي من السيرفر)
    setAdminToken("temp_admin_token");
    navigate(from, { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white border rounded-2xl shadow-sm p-6">
        <h1 className="text-2xl font-extrabold mb-2">
          دخول لوحة التحكم <span className="text-[#4A9FD8]">Alalimi</span>
        </h1>
        <p className="text-sm text-slate-500 mb-6">
          أدخل بيانات الدخول للمتابعة
        </p>

        <form onSubmit={onSubmit} className="space-y-3">
          <input
            className="w-full px-4 py-3 border rounded-xl outline-none focus:ring-2 focus:ring-[#4A9FD8]/30"
            placeholder="اسم المستخدم"
            value={user}
            onChange={(e) => setUser(e.target.value)}
          />

          <input
            type="password"
            className="w-full px-4 py-3 border rounded-xl outline-none focus:ring-2 focus:ring-[#4A9FD8]/30"
            placeholder="كلمة المرور"
            value={pass}
            onChange={(e) => setPass(e.target.value)}
          />

          {err && <div className="text-sm text-red-600">{err}</div>}

          <button
            type="submit"
            className="w-full px-4 py-3 rounded-xl bg-[#4A9FD8] text-white font-semibold hover:bg-[#2E7FB8] transition"
          >
            تسجيل الدخول
          </button>
        </form>
      </div>
    </div>
  );
}
